import {
    getFlowmainstatisticsList
} from '@/api/sys.flowmainstatistics'

export default {
    namespaced: true,
    actions: {
        /**
         * 分页查询
         */
        getflowmainstatisticsList({
                             dispatch
                         }, {
                             vm,
                             pageable
                         }) {
            return getFlowmainstatisticsList(pageable)
                .then(res => {
                    return res
                })
                .catch(err => {
                    vm.loading.close()
                    console.log('err: ', err)
                })
        }
    }
}